import { IndustryItem } from "./Models/SignupData";

export interface ValidBrands {
  AccessCRM: BrandDetail;
  ProspectCRM: BrandDetail;
}

export interface BrandDetail {
  id: string;
  logo: string;
  initialSplash?: string;
  secondSplash?: string;
}

export class Branding {
  public static brands: ValidBrands = {
    AccessCRM: {
      id: "AccessCRM",
      logo: require("./assets/access-freedom.svg"),
      initialSplash: require("./assets/splash/AccessCRM-initial-splash.png"),
      secondSplash: require("./assets/splash/AccessCRM-initial-splash.png"),
    },
    ProspectCRM: {
      id: "ProspectCRM",
      logo: require("./assets/prospect_anaccesscompany_blue.svg"),
      initialSplash: require("./assets/splash/ProspectCRM-initial-splash.png"),
      secondSplash: require("./assets/splash/ProspectCRM-second-splash.png"),
    },
  };

  public static getBrandingParam() {
    const params = new URLSearchParams(window.location.search);
    const brandingParam = params.get("branding") as keyof ValidBrands;
    if (brandingParam && Object.keys(this.brands).includes(brandingParam)) {
      return brandingParam;
    }
  }

  public static isAccessDomain() {
    return window.location.hostname.includes("signup.access-crm");
  }

  public static isAccessBrandedFlow() {
    return this.isAccessDomain() || this.getBrandingParam() === "AccessCRM";
  }

  public static getCurrentBrand() {
    const brand = this.getBrandingParam();
    return brand ? this.brands[brand] : this.brands.ProspectCRM;
  }

  public static getBranding() {
    let setBranding: string | null = null;
    const param = this.getBrandingParam();
    if (param) {
      setBranding = param;
    } else if (this.isAccessDomain()) {
      setBranding = "AccessCRM";
    }
    if (setBranding) {
      this.setFavicons(setBranding);
    }
    return setBranding;
  }

  public static setFavicons(brand: string) {
    const el = document.querySelector("link[rel='icon']");
    if (el) {
      el.setAttribute("href", `/favicon-${brand}.ico`);
    }
  }
}
export class UTMHelper {
  public static utmKeys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
  ];

  public static getUTMParams() {
    const url = new URL(window.location.href);
    const entries: Record<string, string> = {};
    this.utmKeys.forEach((k) => {
      const val = url.searchParams.get(k);
      if (val) {
        entries[k] = val;
      }
    });
    return entries;
  }

  public static hasUTMParams() {
    return this.utmKeys.some((k) => {
      return Object.keys(this.getUTMParams()).includes(k);
    });
  }
}

export class ReferralRock {
  public static getConversionObject(email: string, env: string) {
    return {
      debug: this.debugEnabled(env),
      parameters: {
        email: email,
      },
    };
  }
  public static setConversionObject(email: string, env: string) {
    if (window["referralJS"] !== undefined) {
      window["referralJS"].conversion = this.getConversionObject(email, env);
    }
  }
  public static updateReferral(signupData: {}, leadId: number, env: string) {
    if (window["referralJS"] !== undefined) {
      window["referralJS"].referralUpdate = {
        debug: this.debugEnabled(env),
        parameters: {
          referralkey_email: signupData["Email"],
          firstName: signupData["Forename"],
          lastName: signupData["Surname"],
          companyName: signupData["CompName"],
          phone: signupData["PhoneNumber"],
          externalIdentifier: leadId.toString(),
        },
      };
    }
  }
  public static debugEnabled(env: string) {
    return env === "dv" ? "true" : "false";
  }
}

export function getAllIndustries(): IndustryItem[] {
  return Object.keys(Industries).reduce((prev, curr) => {
    const list = Industries[curr].SubIndustries
      ? Industries[curr].SubIndustries
      : [Industries[curr]];
    return prev.concat(list);
  }, []);
}

export const Industries: IndustryItem[] = [
  {
    Name: "PhysicalProducts",
    StockedProducts: true,
    SubIndustries: [
      {
        Name: "Packaging",
        StandardIndustryCode: "34d4cd",
        StockedProducts: true,
      },
      {
        Name: "Brewing&Distilling",
        StandardIndustryCode: "1e79af",
        StockedProducts: true,
      },
      {
        Name: "CoffeeRoasting",
        StandardIndustryCode: "e2912f",
        StockedProducts: true,
      },
      {
        Name: "OtherFood&Bev",
        StandardIndustryCode: "8e8d76",
        StockedProducts: true,
      },
      {
        Name: "Health&Beauty",
        StandardIndustryCode: "82cdfe",
        StockedProducts: true,
      },
      {
        Name: "Leisure&Fitness",
        StandardIndustryCode: "fb6d84",
        StockedProducts: true,
      },
      {
        Name: "Clothing&Accessories",
        StandardIndustryCode: "ffcc2b",
        StockedProducts: true,
      },
      {
        Name: "Medical&LabEquip",
        StandardIndustryCode: "5e5c76",
        StockedProducts: true,
      },
      {
        Name: "Lighting&Electrical",
        StandardIndustryCode: "807035",
        StockedProducts: true,
      },
      {
        Name: "ITEquipment",
        StandardIndustryCode: "df75aa",
        StockedProducts: true,
      },
      {
        Name: "EngineeringEquipment",
        StandardIndustryCode: "629d03",
        StockedProducts: true,
      },
      {
        Name: "Other",
        StandardIndustryCode: "333fb6",
        StockedProducts: true,
      },
    ],
  },
  {
    Name: "DigitalProducts",
    StandardIndustryCode: "fb1cd6",
    StockedProducts: false,
    IsServices: true,
  },
  {
    Name: "Services",
    StockedProducts: false,
    SubIndustries: [
      {
        Name: "ProfessionalServices",
        StandardIndustryCode: "78c768",
        StockedProducts: false,
        IsServices: true,
      },
      {
        Name: "LegalServices",
        StandardIndustryCode: "00cbf8",
        StockedProducts: false,
        IsServices: true,
      },
      {
        Name: "HealthandSocialCare",
        StandardIndustryCode: "3afe71",
        StockedProducts: false,
        IsServices: true,
      },
      {
        Name: "OtherServices",
        StandardIndustryCode: "333fb6",
        StockedProducts: false,
        IsServices: true,
      },
    ],
  },
  {
    Name: "3rdPartyLogistics",
    StandardIndustryCode: "b5da3c",
    StockedProducts: false,
    IsServices: true,
  },
];
